import React, { FunctionComponent } from 'react';

import withLocation from 'src/router/utils/with-location';
import { LegacyRouteProps } from 'src/sections/repository/types';
import { safeDecodePath } from 'src/utils/path';

import FileHistory from './file-history';
import SourceSection, { SourceSectionProps } from './source-section';

type FileHistoryProps = SourceSectionProps &
  LegacyRouteProps<{
    path: string;
  }>;

const FileHistoryWrapped: FunctionComponent<FileHistoryProps> = routerProps => {
  return (
    <SourceSection {...routerProps}>
      <FileHistory path={safeDecodePath(routerProps.match.params.path)} />
    </SourceSection>
  );
};

export default withLocation(FileHistoryWrapped);
